<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="p-br"><span><em class="i">When Marco Polo lay on his deathbed,<br/> his priest, his friends and relations<br/> clustered around him to plead that he<br/> at last renounce the countless lies he<br/> had related as his true adventures, so his<br/> soul would go cleansed to Heaven. The<br/> old man raised up, roundly damned them<br/> all and declared, “I have not told<br/> the half of what I saw and did!”</em></span></div>
<br/><div class="blocktext"><div class="p-br-blocktext"><span><strong class="b">ACCORDING TO</strong> <br/><strong class="b">FRA JACOPO D’ACQUI,</strong> <br/><strong class="b">MARCO POLO’S CONTEMPORARY</strong> <br/><strong class="b">AND HIS FIRST BIOGRAPHER</strong></span></div></div><br/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429999946_fm02.vue?0c0d88ba